import React, { useState, useEffect } from 'react';

import { logoutNode } from '../../services/auth_node';

const Sair = () => {

  document.title = "Saindo... | Grupo Voitto";

  useEffect(()=>{
   logoutNode();
  }, [])

  return (<></>);
}

export default Sair;